import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'DataTableViewMixin',

  data () {
    return {
      currentView: null
    }
  },

  computed: {
    availableViews () {
      let views = this.dataTableConfiguration.views || [
        Configuration.datatable.TABLE_VIEW_VALUE
      ]

      // ignore unknown view types, e.g. introduced in arpa 3
      views = views.filter(v => { return Configuration.datatable.DEFAULT_AVAILABLE_VIEWS.hasOwnProperty(v) })

      return views.map((v) => {
        const _view = Configuration.datatable.DEFAULT_AVAILABLE_VIEWS[v]
        return { ..._view, text: this.$t(_view.text) }
      }).filter(Boolean)
    },

    isKanbanView () {
      return this.currentView === Configuration.datatable.KANBAN_VIEW_VALUE
    },

    isDashboardView () {
      return this.currentView === Configuration.datatable.DASHBOARD_VIEW_VALUE
    },

    isTableView () {
      return this.currentView === Configuration.datatable.TABLE_VIEW_VALUE
    },

    currentViewIcon () {
      return Configuration.datatable.DEFAULT_VIEWS_ICONS[this.currentView]
    }
  },

  methods: {
    changeView (_nextView) {
      let nextView = _nextView
      if (!this.isValidView(nextView)) {
        nextView = this.availableViews[0].value
        console.debug('Invalid view, fallback to', nextView)
      }

      // When moving kanban => table reset the pageSize to avoid performance issues
      if (this.currentView === Configuration.datatable.KANBAN_VIEW_VALUE &&
        nextView === Configuration.datatable.TABLE_VIEW_VALUE
      ) {
        this.items = []
        this.options.itemsPerPage = this.dataTableConfiguration?.itemsPerPage ? this.dataTableConfiguration.itemsPerPage : 10
      } else if (nextView === Configuration.datatable.KANBAN_VIEW_VALUE) {
        this.items = []
        this.options.itemsPerPage = -1
      }
      this.currentView = nextView
      this.dumpUserAction({ view: nextView })
    },

    isValidView (viewId) {
      return !!this.availableViews.find(v => v.value === viewId)
    }
  }
}
